const registerPage = `plus_register_page(uid: "blt1e7eb4afb662a8f0") {
  title
  url
  disclaimer
  imageConnection {
    edges {
      node {
        url
      }
    }
  }
  offer {
    subheading
    heading
  }
  terms {
    heading
    text
  }
  cta {
    text
  }
}`;

export default registerPage;
